export default "__VITE_ASSET__Da3ZAQnL__"